module.exports = __webpack_public_path__ + "img/13米高栏.51bb8823.jpg";